import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaLock, FaEnvelope, FaArrowLeft } from 'react-icons/fa';
import { useAuth } from '../../contexts/AuthContext';
import { toast } from 'react-toastify';
import LangSwitcher from '../../components/LangSwitcher';
import './Admin.css';

const Login = () => {
  const { t } = useTranslation();
  const { login, currentUser } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [pass, setPass] = useState('');
  const [busy, setBusy] = useState(false);

  if (currentUser) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, pass);
      navigate('/admin');
    } catch (err) {
      toast.error(t('admin.loginError'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-page__bg" />
      <button className="login-back" onClick={() => navigate('/')}>
        <FaArrowLeft /> {t('nav.home')}
      </button>
      <div className="login-lang">
        <LangSwitcher variant="dark" />
      </div>

      <div className="login-card">
        <div className="login-card__header">
          <div className="logo-mark" style={{ width: 56, height: 56, fontSize: '1.6rem' }}>Z</div>
          <h2>ZEL Admin</h2>
          <p>{t('admin.login')}</p>
        </div>

        <form onSubmit={submit} className="login-form">
          <div className="login-field">
            <FaEnvelope />
            <input
              type="email"
              placeholder={t('admin.email')}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="login-field">
            <FaLock />
            <input
              type="password"
              placeholder={t('admin.password')}
              value={pass}
              onChange={(e) => setPass(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary" disabled={busy} style={{ width: '100%' }}>
            {busy ? '...' : t('admin.signIn')}
          </button>
        </form>

        <div className="login-hint">
          Demo: vytvorte používateľa vo Firebase Auth Console.
        </div>
      </div>
    </div>
  );
};

export default Login;
